import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zh from './zh.json';
import en from './en.json';

i18n
  // 自动检测用户浏览器语言
  .use(LanguageDetector)
  // 将 i18n 实例传递给 react-i18next
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en }
    },
    // 默认语言设为中文
    fallbackLng: 'zh',
    interpolation: {
      escapeValue: false // React 已经防范了 XSS，这里设为 false
    }
  });

export default i18n;